import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useSignatureEnvelope } from '~/core/shared/api/signature';
import { useRequiredParams } from '~/core/shared/hooks';
import { Envelope } from '~/core/shared/types';
import { TenantDocumentRouteProps } from '../../../config';
import { EnvelopeForm } from '../../envelopes/EnvelopeForm.component';
import { DocumentDetails } from '../Details.view';

interface ExtendedTenantDocumentRouteProps extends TenantDocumentRouteProps {
  envelopesListingPath: string;
}

export const ApplicationEnvelopesEdit: FC<ExtendedTenantDocumentRouteProps> = (
  props,
) => {
  const { envelope: envelopeId } = useRequiredParams(['envelope']);
  const form = useForm<Envelope>();

  const { envelopesListingPath, ...restProps } = props;

  const { envelope } = useSignatureEnvelope(envelopeId, {
    include: 'instances.template.roles.fields',
  });

  return (
    <DocumentDetails {...restProps} tenantTabName="envelopes">
      <FormProvider {...form}>
        {envelope && (
          <EnvelopeForm
            envelope={envelope}
            envelopesListingPath={envelopesListingPath}
          />
        )}
      </FormProvider>
    </DocumentDetails>
  );
};
